import styled, { css } from 'styled-components';
import { theme } from "../themes";

export const baseContent = css`
  line-height: 1.3;
  font-size: 1.2rem;

  h1, h2, h3, h4, h5, h6 {
    margin-top: 2rem;
    @include heading-style;
  }

  & > * {
    margin: 1rem 0;
  }

  hr, blockquote, .youtube-iframe {
    @media (min-width: var(--breakpoint-medium)) {
      margin: 2rem 0rem;
    }
  }

  ol {
    list-style: decimal;
    padding-left: 2.5rem;
  }

  ul {
    li {
      position: relative;
      padding-left: 2rem;
      &::before {
        content: "•";
        color: var(--color-primary);
        position: absolute;
        left: .9rem;
      }
    }
  }

  a {
    box-shadow: inset 0 -.45rem 0 0 rgba(var(--color-primary), .10);
    &:hover {
      box-shadow: inset 0 -2.5rem 0 0 rgba(var(--color-primary), .10)
    }
  }

  table {
    border: 0 solid transparent;
  }

  img {
    margin: auto;
    height: 100% !important;
  }

  blockquote {
    border-left: 3px solid var(--color-primary);
    padding: 1rem;
    background-color: rgba(var(--color-primary), .05);
    @media (min-width: var(--breakpoint-medium)) {
      font-size: 1.5rem;
    }
    p:first-child {
      margin-top: 0;
    }
  }

  .youtube-iframe {
    @include card-style;
    position: relative;
    padding-top: 56.25%;
    iframe[src*="youtube"] {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
    }
  }
`
